import React from 'react';
import PageHeader from '../components/PageHeader';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Experience = () => {
  const capabilities = [
    { title: 'Emergency Management', icon: FiIcons.FiShield },
    { title: 'Training & Development', icon: FiIcons.FiTarget },
    { title: 'Drills & Exercises', icon: FiIcons.FiActivity },
    { title: 'Leadership Development', icon: FiIcons.FiUsers }
  ];

  const pastPerformance = [
    'Graded full-scale exercise for a nuclear-fuel facility',
    'Contract instruction for the National Fire Academy',
    'Work at FEMA Joint Field Offices during declared disasters',
    'Safety plans for high-voltage industrial manufacturers',
    'Subject-matter expertise for a U.S. Department of State hazardous-materials project',
    'Standard operating procedures for a ConocoPhillips site',
    'Accident-investigation policies and training for oil and gas terminals',
    'Emergency planning, EOC, fire protection, and commissioning work for industrial and energy operations',
    'Leadership-academy design and delivery for industrial employers',
    'Service to clients in more than 30 countries'
  ];

  return (
    <div className="w-full bg-brand-light min-h-screen">
      <PageHeader 
        title="Experience & Capabilities" 
        description="Proven results across nuclear, industrial, government, and international sectors." 
      />
      
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="bg-brand-navy rounded-2xl p-8 md:p-12 shadow-xl mb-20 text-white">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <h3 className="text-brand-green font-bold uppercase tracking-wider text-sm mb-4">Core Competencies</h3>
            </div>
            {capabilities.map((cap, i) => (
              <div key={i} className="flex items-center gap-3">
                <SafeIcon icon={cap.icon} className="text-brand-green text-2xl shrink-0" />
                <span className="font-bold">{cap.title}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-8">
            <h2 className="text-3xl font-bold text-brand-navy mb-8">Selected Past Performance</h2>
            <div className="space-y-4">
              {pastPerformance.map((item, i) => (
                <div key={i} className="flex items-start gap-4 p-5 bg-white border border-slate-200 rounded-xl hover:border-brand-green transition-colors shadow-sm">
                  <div className="mt-1 bg-brand-light p-1 rounded text-brand-green shrink-0">
                    <SafeIcon icon={FiIcons.FiCheck} />
                  </div>
                  <p className="text-slate-700 font-medium leading-relaxed m-0">{item}</p>
                </div>
              ))}
            </div>
            
            <div className="mt-8 bg-slate-50 border-l-4 border-brand-gray p-4 rounded-r-lg text-sm text-slate-600 font-medium italic">
              Note: Client names and specific facility locations are shared only after written permission is confirmed or when part of the public record.
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="bg-white rounded-2xl p-8 border border-slate-200 shadow-sm sticky top-28">
              <h3 className="text-xl font-bold text-brand-navy mb-6 border-b border-slate-100 pb-4">Company Details</h3>
              <ul className="space-y-6">
                <li>
                  <span className="block text-xs font-bold text-brand-gray uppercase tracking-wider mb-1">CAGE Code</span>
                  <span className="font-semibold text-slate-900">9UV45</span>
                </li>
                <li>
                  <span className="block text-xs font-bold text-brand-gray uppercase tracking-wider mb-1">UEI</span>
                  <span className="font-semibold text-slate-900">JXU6AB8GAPE7</span>
                </li>
                <li>
                  <span className="block text-xs font-bold text-brand-gray uppercase tracking-wider mb-2">NAICS Codes</span>
                  <div className="flex flex-wrap gap-2">
                    {['922190', '611430', '624230', '541612', '611710'].map(code => (
                      <span key={code} className="px-2 py-1 bg-brand-light border border-slate-200 rounded text-sm font-semibold text-slate-700">
                        {code}
                      </span>
                    ))}
                  </div>
                </li>
              </ul>
              
              <button className="w-full mt-8 py-4 bg-brand-navy text-white font-bold rounded-xl hover:bg-slate-800 transition-colors shadow-lg flex items-center justify-center gap-2">
                <SafeIcon icon={FiIcons.FiDownload} /> capability statement
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Experience;